import { FC } from 'react';
import type { BundlePropType } from '@commerce-product-webcomponents/ui';
import { CartCardComponent } from '../Organisms';
import type { ProductCartEntryComponentPropsTypes } from './types/propsTypes';

const ProductCartEntryComponent: FC<ProductCartEntryComponentPropsTypes> = (
  props: ProductCartEntryComponentPropsTypes,
): JSX.Element => <CartCardComponent {...props} />;

export default ProductCartEntryComponent;
export type { ProductCartEntryComponentPropsTypes, BundlePropType };
